import React, { useState } from 'react';

const ContactFormModal = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    requirements: '',
    captcha: ''
  });

  const [captchaQuestion] = useState({
    num1: Math.floor(Math.random() * 10) + 1,
    num2: Math.floor(Math.random() * 10) + 1
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email';
    }

    if (!formData.requirements.trim()) {
      newErrors.requirements = 'Please describe your requirements';
    } else if (formData.requirements.trim().length < 20) {
      newErrors.requirements = 'Please provide more details (at least 20 characters)';
    }

    const correctAnswer = captchaQuestion.num1 + captchaQuestion.num2;
    if (!formData.captcha) {
      newErrors.captcha = 'Please solve the captcha';
    } else if (parseInt(formData.captcha) !== correctAnswer) {
      newErrors.captcha = 'Incorrect answer, please try again';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    // Simulate API call - Replace with actual API endpoint
    setTimeout(() => {
      console.log('Form submitted:', formData);
      setIsSubmitting(false);
      setSubmitSuccess(true);

      setTimeout(() => {
        onClose();
      }, 2000);
    }, 1000);
  };

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains('contact-modal')) {
      onClose();
    }
  };

  if (submitSuccess) {
    return (
      <div className="contact-modal active" onClick={handleBackdropClick}>
        <div className="contact-modal-content">
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h2>Thank You!</h2>
            <p>We've received your project request. Our team will contact you within 24 hours.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-modal active" onClick={handleBackdropClick}>
      <div className="contact-modal-content">
        <button className="close-modal" onClick={onClose}>&times;</button>
        
        <div className="contact-modal-header">
          <h2>Start Your Project</h2>
          <p>Tell us about your project and we'll get back to you within 24 hours</p>
        </div>

        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="name">Full Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={errors.name ? 'error' : ''}
              placeholder="Enter your full name"
            />
            {errors.name && <span className="error-message">{errors.name}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={errors.email ? 'error' : ''}
              placeholder="your.email@example.com"
            />
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="requirements">Summarize Your Requirements *</label>
            <textarea
              id="requirements"
              name="requirements"
              value={formData.requirements}
              onChange={handleChange}
              className={errors.requirements ? 'error' : ''}
              placeholder="Describe your project, goals, timeline, budget, and any specific requirements..."
              rows="5"
            />
            <div className="char-count">
              {formData.requirements.length} characters (minimum 20)
            </div>
            {errors.requirements && <span className="error-message">{errors.requirements}</span>}
          </div>

          <div className="form-group captcha-group">
            <label htmlFor="captcha">Security Check *</label>
            <div className="captcha-question">
              What is {captchaQuestion.num1} + {captchaQuestion.num2}?
            </div>
            <input
              type="number"
              id="captcha"
              name="captcha"
              value={formData.captcha}
              onChange={handleChange}
              className={errors.captcha ? 'error' : ''}
              placeholder="Enter the answer"
            />
            {errors.captcha && <span className="error-message">{errors.captcha}</span>}
          </div>

          <div className="form-actions">
            <button type="button" onClick={onClose} className="btn-secondary">
              Cancel
            </button>
            <button type="submit" className="btn-primary" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Submit Request'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactFormModal;
